import React, { useContext } from 'react';
import { Alert, Typography } from '@pw-tech/omni-ui';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import BasicDetailsForm from './BasicDetailsForm';
const BasicDetails = () => {
  const {
    registrationDetails
  } = useContext(RegistrationContext);
  return <>
      <div className="flex flex-col gap-6">
        <Typography variant="heading3" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="BasicDetails.tsx">
          Enter Your Basic Details
        </Typography>
        {registrationDetails?.tenthPercentage && <Typography variant="heading4" weight="semi-bold">
            Personal Details
          </Typography>}
      </div>
      <Alert heading="Please ensure all details below belong to the Student applying for the program." intent="info" fullWidth data-sentry-element="Alert" data-sentry-source-file="BasicDetails.tsx" />
      <BasicDetailsForm data-sentry-element="BasicDetailsForm" data-sentry-source-file="BasicDetails.tsx" />
    </>;
};
export default BasicDetails;